import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { X } from 'lucide-react';
import { theme } from '../../design-system';

const Bar = styled.div`
  background: ${theme.colors.primary[600]};
  color: #fff;
  font-size: 0.85rem;
  padding: 8px 16px;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  text-align: center;
`;

const Message = styled.a`
  color: #fff;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const SponsoredTag = styled.span`
  font-size: 0.7rem;
  font-weight: 400;
  opacity: 0.75;
  margin-left: 6px;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  background: transparent;
  border: none;
  color: #fff;
  opacity: 0.8;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;

  &:hover {
    opacity: 1;
  }
`;

const dismissedKey = (adId) => `topbar_dismissed_${adId}`;

const TopAnnouncementBar = () => {
  const location = useLocation();
  const [ad, setAd] = useState(null);

  useEffect(() => {
    const cityMatch = location.pathname.match(/^\/businesses\/([^/]+)/);
    const citySlug = cityMatch ? cityMatch[1] : '';

    const params = new URLSearchParams({ placement: 'top_bar' });
    if (citySlug) params.set('city', citySlug);

    fetch(`/api/ads/serve/?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.id && sessionStorage.getItem(dismissedKey(data.id)) !== '1') {
          setAd(data);
        } else {
          setAd(null);
        }
      })
      .catch(() => setAd(null));
  }, [location.pathname]);

  if (!ad) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(dismissedKey(ad.id), '1');
    setAd(null);
  };

  return (
    <Bar>
      <Inner>
        <Message href={ad.ad_URL} target="_blank" rel="noopener noreferrer sponsored">
          {ad.ad_title}
          <SponsoredTag>Sponsored</SponsoredTag>
        </Message>
        <CloseButton onClick={handleDismiss} aria-label="Dismiss">
          <X size={16} />
        </CloseButton>
      </Inner>
    </Bar>
  );
};

export default TopAnnouncementBar;
